import {Image} from 'antd';
import {ReactElement, useCallback, useMemo, useState} from 'react';

import {classNames} from '../../../../../../../util/css';
import {useReviewMediaPreview} from '../../../../review-media-preview-provider';

import {GalleryPreviewOverlay} from './gallery-preview-overlay';
import {buildGalleryMediaItems} from './preview-group-media';
import {PreviewGroupVideoTile} from './preview-group-video-tile';
import * as styles from './preview-group.scss';

type ImageItemType = {src: string | null; alt: string | null} | HTMLImageElement;

type PropsType = {
    images?: Array<ImageItemType>;
    videos?: Array<{src: string | null; poster: string | null}>;
    imageClassName?: string;
};

export function PreviewGroup(props: PropsType): ReactElement | null {
    const {images, videos, imageClassName} = props;
    const mediaPreview = useReviewMediaPreview();
    const [localOverlayIndex, setLocalOverlayIndex] = useState<number | null>(null);

    const mediaItems = useMemo(() => buildGalleryMediaItems(images, videos), [images, videos]);

    const openAtIndex = useCallback(
        (index: number) => {
            if (mediaPreview) {
                mediaPreview.openGallery(mediaItems, index);
                return;
            }

            setLocalOverlayIndex(index);
        },
        [mediaItems, mediaPreview]
    );

    if (mediaItems.length === 0) {
        return null;
    }

    return (
        <>
            <div className={classNames(styles.ImageGallery, styles.ImageGallery_list)}>
                <div className={styles.ImageGallery_track}>
                    {mediaItems.map((item, index) => {
                        if (item.type === 'image') {
                            return (
                                <Image
                                    // eslint-disable-next-line no-undefined
                                    alt={item.alt ?? undefined}
                                    className={classNames(styles.ImageGallery_image, imageClassName)}
                                    key={item.key}
                                    onClick={() => {
                                        openAtIndex(index);
                                    }}
                                    preview={false}
                                    src={item.src}
                                    wrapperClassName={styles.ImageGallery_wrapper}
                                />
                            );
                        }

                        return (
                            <PreviewGroupVideoTile
                                imageClassName={imageClassName}
                                key={item.key}
                                onClick={() => {
                                    openAtIndex(index);
                                }}
                                poster={item.poster}
                                videoSrc={item.src}
                            />
                        );
                    })}
                </div>
            </div>
            {localOverlayIndex !== null && (
                <GalleryPreviewOverlay
                    initialIndex={localOverlayIndex}
                    mediaItems={mediaItems}
                    onClose={() => {
                        setLocalOverlayIndex(null);
                    }}
                />
            )}
        </>
    );
}
